import { render, staticRenderFns } from "./formularioVehiculo.vue?vue&type=template&id=0a54ed64&scoped=true"
import script from "./formularioVehiculo.vue?vue&type=script&lang=js"
export * from "./formularioVehiculo.vue?vue&type=script&lang=js"
import style0 from "./formularioVehiculo.vue?vue&type=style&index=0&id=0a54ed64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54ed64",
  null
  
)

export default component.exports